import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BrandMark from "../components/BrandMark";

const ComingSoonPage: React.FC = () => {
  useEffect(() => {
    const previous = document.title;
    document.title = "Coming soon | PEAK";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="min-h-screen bg-base-100 text-base-content">
      <header className="border-b border-base-200">
        <div className="mx-auto flex max-w-5xl items-center px-4 py-4 sm:px-6">
          <Link to="/" aria-label="PEAK home">
            <BrandMark />
          </Link>
        </div>
      </header>
      <main className="mx-auto flex min-h-[70vh] max-w-xl items-center justify-center px-4 text-center">
        <h1 className="font-heading text-5xl font-semibold tracking-tight sm:text-6xl">
          Coming soon
        </h1>
      </main>
    </div>
  );
};

export default ComingSoonPage;
